import {Injectable} from '@angular/core';
import {Storage} from '@ionic/storage';
import {NavParamService} from './navparams';
import {Store} from './store';

@Injectable()
export class StorageProvider {

    constructor(public storage: Storage, public nav: NavParamService) {
        this.storage.ready().then(() => {
        });
    }

    fetchToken() {
        return this.storage.get('scope_token');
    }

    fetchValue(key: string) {
        return this.storage.get(key);
    }

    storeValue(key: string, val: string) {
        return this.storage.set(key, val);
    }

    storeToken(val: string) {
        return this.storeValue('scope_token', val);
    }

    store() {
        return new Promise((resolve, reject) => {
            try {
                this.storage.length().then((len) => {
                    const store = new Store();
                    if (len > 0) {
                        this.storage.forEach((value, key, itr) => {
                            if (itr == len) {
                                resolve(store);
                            }
                        });
                    } else {
                        resolve(store);
                    }
                });
            } catch (e) {
            }
        });
    }

    removeKey(key: string) {
        return this.storage.remove(key);
    }

    isReady() {
        return this.storage.ready();
    }

    clear() {
        return this.storage.clear();
    }
}
